import request from '../../utils/request';

export default params => request('/invoice-information/search', { params });
